import { render, staticRenderFns } from "./NovoPedidoView.vue?vue&type=template&id=10472460&"
import script from "./NovoPedidoView.vue?vue&type=script&lang=js&"
export * from "./NovoPedidoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports